import DataTable from 'components/organisms/data-table'
import InternalRequestItemTableColumns from './internal-request-item-table-columns'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'


const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  rowButtonProps : PropTypes.arrayOf(PropTypes.object),
  hiddenColumns  : PropTypes.array
}

const defaultProps = {
  data           : [],
  pagination     : {},
  onFetchData    : () => {},
  isLoading      : false,
  rowButtonProps : [],
  hiddenColumns  : []
}

/**
 * Domain-specifc DataTable for Internal Request Items
 * @param {object[]} data - array of Internal Request objects
 * @param {object} pagination - object of pagination data from endpoint
 * @param {func} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 * @param {array} hiddenColumns - Hide specific columns by id
 */
const InternalRequestItemTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  isLoading,
  hiddenColumns
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const columns = useMemo(() => InternalRequestItemTableColumns({ rowButtonProps }), [ rowButtonProps ])

  return (
    <DataTable
      data={ data }
      pagination={ pagination }
      onFetchData={ onFetchData }
      columns={ columns }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

InternalRequestItemTable.propTypes    = propTypes
InternalRequestItemTable.defaultProps = defaultProps

export default InternalRequestItemTable
